import cx from 'classnames';
import React, { forwardRef } from 'react';

const DefinitionListHeader = ({
  icon = undefined,
  title,
  titleClassName = '',
}) => (
  <h2 className={cx('flex', 'items-center')}>
    {icon && React.createElement(icon, { className: cx('h-4') })}
    <span
      className={cx('font-bold', 'text-lg', icon && 'ml-4', titleClassName)}
    >
      {title}
    </span>
  </h2>
);

export default DefinitionListHeader;
